import React, { FunctionComponent } from 'react'
import { Loader, Text } from '@afterpaytouch/core'

interface Props {
  show?: boolean
  label?: string
  testNameSpace?: string
}

export const LoaderTitle: FunctionComponent<Props> = ({ show = false, label = '', testNameSpace = '' }) => {
  if (!show || !label) {
    return null
  }

  return (
    <>
      <Loader testNameSpace={testNameSpace} />
      <Text size='S' bold>
        {label}
      </Text>
    </>
  )
}
